export default {
    mounted(el, binding) {
        const resizeTextarea = () => {
            const scrollTop = el.scrollTop;
            el.style.height = '1px';
            const newHeight = Math.max(el.scrollHeight, 52);
            el.style.height = newHeight + 'px';
            el.scrollTop = scrollTop;
        };

        el._resizeTextarea = resizeTextarea;

        el.style.minHeight = '52px';
        el.style.overflow = 'hidden';
        el.style.resize = 'none';
        el.style.boxSizing = 'border-box';
        el.style.flexShrink = '0';
        el.style.alignSelf = 'stretch';

        el.addEventListener('input', resizeTextarea);
        el.addEventListener('paste', () => {
            setTimeout(resizeTextarea, 0);
        });
        window.addEventListener('resize', resizeTextarea);

        setTimeout(resizeTextarea, 0);
    },

    updated(el, binding) {
        if (el._resizeTextarea) {
            setTimeout(el._resizeTextarea, 0);
        }
    },

    beforeUnmount(el) {
        if (el._resizeTextarea) {
            el.removeEventListener('input', el._resizeTextarea);
            el.removeEventListener('paste', el._resizeTextarea);
            window.removeEventListener('resize', el._resizeTextarea);
            delete el._resizeTextarea;
        }
    }
};
